import { useCallback } from "react"

import { BASE_MAP_ID, useMapDispatchContext } from "@l2r-front/l2r-map"

export const useGetViewCenter = (mapId = BASE_MAP_ID) => {
    const { getMapRef } = useMapDispatchContext()

    const getViewCenter = useCallback(() => {
        const mapRef = getMapRef(mapId)
        if (mapRef) {
            const center = mapRef.getCenter()
            return {
                latitude: center.lat,
                longitude: center.lng,
            }
        }

        return null
    }, [getMapRef, mapId])

    return getViewCenter
}

export const useGetMapZoom = (mapId = BASE_MAP_ID) => {
    const { getMapRef } = useMapDispatchContext()
    const mapRef = getMapRef(mapId)

    if (mapRef) {
        return mapRef.getZoom()
    }

    return null
}